import TournamentDetails from "../../../../ReusableComponent/TournamentDetails"

const TournamentsDetailPage = () => {
  const tournamentData = {
    title: "QuizStudio Coding Challenge",
    badges: ["Beginner Friendly", "Online"],
    prizePool: "$5000",
    description: "Compete with coders worldwide and test your skills.",
    startsIn: "2 Days",
    participants: 120,
    problems: 10,
    rating: 4.9,
    rules: "Follow fair play rules. No plagiarism allowed.",
    categories: ["Algorithms", "Data Structures", "Math", "General Knowledge"],
    registerLink: "#",

    // Prize distribution
    prizes: [
      { position: "1st Place", reward: "$2500" },
      { position: "2nd Place", reward: "$1500" },
      { position: "3rd Place", reward: "$1000" },
    ],

    // Sponsors
    sponsors: [
      { name: "OpenAI", logo: "/images/openai.png" },
      { name: "GitHub", logo: "/images/github.png" },
    ],
  };

  return (
    <div>
      <TournamentDetails tournamentData={tournamentData} />
    </div>
  );
};

export default TournamentsDetailPage;